import { render, staticRenderFns } from "./WFilterButton.vue?vue&type=template&id=5be51fe6&scoped=true&"
import script from "./WFilterButton.vue?vue&type=script&lang=js&"
export * from "./WFilterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be51fe6",
  null
  
)

export default component.exports